import { FilterInput } from './../../models/filter-objects';

import { Component, Input, NgModule, EventEmitter, Output, ChangeDetectionStrategy, ElementRef, OnInit } from '@angular/core';

@Component({
    selector: 'app-dropdown-filter',
    templateUrl: './dropdown-filter.component.html',
    styleUrls: ['./dropdown-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DropdownFilterComponent implements OnInit {
	filterData: OverviewFilterInput | FilterInput;

	@Input() selectedRows: string[] = [];
	@Input() selectionMode: 'multiple' | 'single' = 'multiple';

	@Output() selectedItems = new EventEmitter<DropdowndSelectedValues>();
	@Input() set data(arr: OverviewFilterInput | FilterInput) {
		this.filterData = arr;
		
	};

	@Output()
	public onClosed: EventEmitter<any> = new EventEmitter<any>();

	public selectionChangedHandler(event: any) {
		this.setNewValue(event.selectedRowKeys);
	}

	public valueChanged(event: any) {
		this.setNewValue(event.value);
	}

	private setNewValue(value: any) {
		const dropDownSelectedValue = new DropdowndSelectedValues();
		dropDownSelectedValue.selectionId = this.filterData.selectionId;
		dropDownSelectedValue.values = value ? value : [];
		this.selectedItems.emit(dropDownSelectedValue);
	}

	constructor(
		private elRef: ElementRef,
		// public consoleService: ConsoleService,
	) { }

	ngOnInit(): void {
	}
}

import {
	DxTemplateModule,
	DxAutocompleteModule,
	DxButtonModule,
	DxDropDownBoxModule,
	DxDataGridModule,
} from 'devextreme-angular';
import { CommonModule } from '@angular/common';
import { OverviewFilterInput } from 'src/app/pages/stock/stock.service';
@NgModule({
	declarations: [ DropdownFilterComponent ],
	exports: [ DropdownFilterComponent ],
	imports: [ DxAutocompleteModule, DxTemplateModule, DxButtonModule, DxDropDownBoxModule,
		DxDataGridModule, CommonModule ]
})
export class DropDownFilterModule { }

export class DropdowndSelectedValues {
	selectionId: number;
	values: string[];
}
